import { playSound } from 'utils/notificationAudio';

/**
 * Notifications whose arrival should NOT play a ringer at all.
 * Background updates that don't need the operator's attention.
 */
const SILENT_TITLES = new Set<string>(['Ticket Update', 'Table Order Update']);

/**
 * Notifications that demand the operator's attention until acknowledged —
 * play the looping ringer (auto-stops after 4 min).
 */
const LOOP_TITLES = new Set<string>(['New Online Order', 'New In Store Order']);

/**
 * Decide which ringer (if any) to play for an incoming push notification.
 *
 * Mirrors the rules that used to live in electron/src/push.js fnNotify so the
 * operator hears the same audio cues as before:
 *   - Silent titles                 → no sound
 *   - Loop titles + body not "cancelled" → loop notification.mp3 (auto-stops at 4 min)
 *   - Anything else                 → single-shot Notification1.mp3
 *
 * Pure decision function — no side effects beyond the playSound() call.
 */
export function playNotificationRinger(message: any): void {
  const title = message?.title;
  if (SILENT_TITLES.has(title)) return;

  const cancelled = (message?.message || '').toLowerCase().includes('cancelled');
  if (LOOP_TITLES.has(title) && !cancelled) {
    playSound('notification', true);
  } else {
    playSound('notification1');
  }
}
